(function () {
  if (window.__NYC_MTM_HANDLER_FINAL_V11__) return;
  window.__NYC_MTM_HANDLER_FINAL_V11__ = true;

  function isMtmText(text) {
    return String(text || '').trim().toLowerCase().includes('made to measure');
  }

  function keepScroll() {
    var x = window.scrollX, y = window.scrollY;
    var restore = function () { window.scrollTo(x, y); };
    requestAnimationFrame(restore);
    setTimeout(restore, 100);
    setTimeout(restore, 300);
  }

  function triggerChange(select) {
    if (!select) return;
    /* inside quick view/modal, synthetic events make the theme re-render the
       modal content (losing the close button) — set the value silently there */
    if (select.closest && select.closest('.quick-product--wrap, .modal, .popover, .drawer')) return;

    keepScroll();
    select.dispatchEvent(new Event('input', { bubbles: true }));
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function getForm(button) {
    var directForm =
      button.closest('form[data-product-form]') ||
      button.closest('form[action*="/cart/add"]') ||
      button.closest('form');

    if (directForm) return directForm;

    var productScope =
      button.closest('.quick-product--wrap') ||
      button.closest('.quick-product') ||
      button.closest('.product__details') ||
      button.closest('.product') ||
      button.closest('section') ||
      document;

    return (
      productScope.querySelector('form[data-product-form]') ||
      productScope.querySelector('form[action*="/cart/add"]') ||
      productScope.querySelector('form')
    );
  }

  function getScope(button, form) {
    return (
      button.closest('.quick-product--wrap') ||
      button.closest('.quick-product') ||
      button.closest('.modal') ||
      button.closest('.popover') ||
      button.closest('.drawer') ||
      button.closest('.product') ||
      button.closest('.product__details') ||
      form ||
      document
    );
  }

  function getSizeSelect(button, form) {
    var scope = getScope(button, form);

    return (
      form.querySelector('select[name="options[Size]"]') ||
      form.querySelector('select[name="options[size]"]') ||
      form.querySelector('select[name^="options["]') ||
      scope.querySelector('select[name="options[Size]"]') ||
      scope.querySelector('select[name="options[size]"]') ||
      scope.querySelector('select[name^="options["]')
    );
  }

  function getWrapper(form) {
    return form.querySelector('.mtm-wrapper');
  }

  function getFields(form) {
    return form.querySelector('.made-to-measure-fields');
  }

  function getSelectedText(select) {
    if (!select || select.selectedIndex < 0 || !select.options[select.selectedIndex]) {
      return '';
    }

    return select.options[select.selectedIndex].textContent.trim();
  }

  function savePreviousSize(button, select) {
    var currentText = getSelectedText(select);

    if (!isMtmText(currentText)) {
      button.setAttribute('data-prev-size-index', select.selectedIndex);
      button.setAttribute('data-prev-size-value', select.value);
      button.setAttribute('data-prev-size-text', currentText);
    }
  }

  function selectMadeToMeasure(select) {
    if (!select) return false;

    if (isMtmText(getSelectedText(select))) return true;

    for (var i = 0; i < select.options.length; i++) {
      var optionText = select.options[i].textContent.trim();

      if (isMtmText(optionText)) {
        select.selectedIndex = i;
        select.value = select.options[i].value;
        triggerChange(select);
        return true;
      }
    }

    return false;
  }

  function restorePreviousSize(button, select) {
    if (!select) return;

    var prevValue = button.getAttribute('data-prev-size-value');
    var prevIndex = button.getAttribute('data-prev-size-index');

    if (prevValue) {
      select.value = prevValue;

      if (select.value === prevValue) {
        triggerChange(select);
        return;
      }
    }

    if (prevIndex !== null && prevIndex !== '' && select.options[Number(prevIndex)]) {
      select.selectedIndex = Number(prevIndex);
      triggerChange(select);
      return;
    }

    select.selectedIndex = 0;
    triggerChange(select);
  }

  function clearMtmFields(fields) {
    if (!fields) return;

    fields.querySelectorAll('input, textarea').forEach(function (input) {
      if (input.type === 'checkbox' || input.type === 'radio') {
        input.checked = false;
      } else {
        input.value = '';
      }
    });
  }

  function addHiddenProperty(form) {
    if (!form) return;

    var input = form.querySelector('input[name="properties[Size Type]"]');

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[Size Type]';
      form.appendChild(input);
    }

    input.value = 'Made to Measure';
  }

  function removeHiddenProperty(form) {
    if (!form) return;

    var input = form.querySelector('input[name="properties[Size Type]"]');

    if (input) {
      input.remove();
    }
  }

  function openMtm(button, form, select, wrapper) {
    savePreviousSize(button, select);

    wrapper.style.display = 'block';
    wrapper.classList.add('mtm-opened');

    button.classList.add('is-selected');
    button.setAttribute('data-mtm-open', 'true');

    selectMadeToMeasure(select);
    addHiddenProperty(form);

    console.log('MTM opened. Previous size:', button.getAttribute('data-prev-size-text'));
  }

  function closeMtm(button, form, select, wrapper, fields) {
    clearMtmFields(fields);

    wrapper.style.display = 'none';
    wrapper.classList.remove('mtm-opened');

    button.classList.remove('is-selected');
    button.setAttribute('data-mtm-open', 'false');

    restorePreviousSize(button, select);
    removeHiddenProperty(form);

    console.log('MTM closed. Restored size:', button.getAttribute('data-prev-size-text'));
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.js-mtm-button');

    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    var form = getForm(button);

    if (!form) {
      console.warn('MTM form not found');
      return;
    }

    var select = getSizeSelect(button, form);
    var wrapper = getWrapper(form);
    var fields = getFields(form);

    if (!select || !wrapper || !fields) {
      console.warn('MTM missing element', {
        select: !!select,
        wrapper: !!wrapper,
        fields: !!fields
      });
      return;
    }

    var isOpen =
      button.getAttribute('data-mtm-open') === 'true' ||
      wrapper.classList.contains('mtm-opened') ||
      wrapper.style.display === 'block';

    if (isOpen) {
      closeMtm(button, form, select, wrapper, fields);
    } else {
      openMtm(button, form, select, wrapper);
    }

    /* legacy scroll/style hacks removed: they broke Stiletto v6's modal scroll lock */
  }, true);

  document.addEventListener('click', function (event) {
    var sizeButton = event.target.closest('.product__size-button');

    if (!sizeButton) return;

    /* The theme moves to a variant's featured image after an option change.
       If the mobile carousel has not initialised, that fallback can scroll the
       whole page back to the gallery. Keep the customer's reading position. */
    keepScroll();

    var form = getForm(sizeButton);
    if (!form) return;

    var select = getSizeSelect(sizeButton, form);
    var mtmButton = form.querySelector('.js-mtm-button');
    var requestedSize = sizeButton.getAttribute('data-option-value') || '';

    if (isMtmText(requestedSize) && mtmButton && select) {
      savePreviousSize(mtmButton, select);
    }

    setTimeout(function () {
      var wrapper = getWrapper(form);
      var fields = getFields(form);

      if (isMtmText(requestedSize)) {
        if (mtmButton && select && wrapper) {
          openMtm(mtmButton, form, select, wrapper);
        }
        return;
      }

      clearMtmFields(fields);
      removeHiddenProperty(form);

      if (wrapper) {
        wrapper.style.display = 'none';
        wrapper.classList.remove('mtm-opened');
      }

      if (mtmButton) {
        mtmButton.classList.remove('is-selected');
        mtmButton.setAttribute('data-mtm-open', 'false');
      }
    }, 0);
  }, true);

  document.addEventListener('change', function (event) {
    var select = event.target;

    if (!select.matches('select[name^="options["]')) return;

    /* Apply the same protection when the editor's dropdown style is used. */
    keepScroll();
  }, true);

  document.addEventListener('input', function (event) {
    var input = event.target;

    if (!input.closest('.mtm-wrapper')) return;

    var form = input.closest('form');
    if (!form) return;

    var button = form.querySelector('.js-mtm-button');
    var select = button ? getSizeSelect(button, form) : getSizeSelect(input, form);

    if (select) {
      selectMadeToMeasure(select);
    }
  });

  document.addEventListener('change', function (event) {
    var select = event.target;

    if (!select.matches('select[name^="options["]')) return;

    var selectedText = getSelectedText(select);
    var form = select.closest('form');
    if (!form) return;

    var wrapper = getWrapper(form);
    var fields = getFields(form);
    var button = form.querySelector('.js-mtm-button');

    if (isMtmText(selectedText)) {
      if (button && wrapper) {
        openMtm(button, form, select, wrapper);
      }
      return;
    }

    clearMtmFields(fields);
    removeHiddenProperty(form);

    if (wrapper) {
      wrapper.style.display = 'none';
      wrapper.classList.remove('mtm-opened');
    }

    if (button) {
      button.classList.remove('is-selected');
      button.setAttribute('data-mtm-open', 'false');
    }
  });
})();
